const languages = {
  en: {
    iso: 'en',
    short: 'EN',
    long: 'English',
    sbe: 'en',
    adGlare: 'en_gb',
  },
  tc: {
    iso: 'zh-hk',
    short: '繁',
    long: '繁體中文',
    sbe: 'zh',
    adGlare: 'zh_hant',
  },
  sc: {
    iso: 'zh-cn',
    short: '简',
    long: '简体中文',
    sbe: 'cn',
    adGlare: 'zh_hans',
  },
  de: {
    iso: 'de',
    short: 'DE',
    long: 'German',
    sbe: 'de',
    adGlare: 'de',
  },
  it: {
    iso: 'it',
    short: 'IT',
    long: 'italian',
    sbe: 'it',
    adGlare: 'it',
  },
  es: {
    iso: 'es',
    short: 'DE',
    long: 'Spanish',
    sbe: 'es',
    adGlare: 'es',
  },
};

export default languages;
